import { render, staticRenderFns } from "./ApprovalRequestActions.vue?vue&type=template&id=8d849d78&"
import script from "./ApprovalRequestActions.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequestActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports